// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w_AMlckPrZYmxvgKP2kl{flex-direction:column;gap:16px;display:flex}.yXge653HiYEteNIHw1gG{padding-left:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `w_AMlckPrZYmxvgKP2kl`,
	"textField": `yXge653HiYEteNIHw1gG`
};
export default ___CSS_LOADER_EXPORT___;
